import script from "./oneClickDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./oneClickDialog.vue?vue&type=script&lang=ts&setup=true"

import "./oneClickDialog.vue?vue&type=style&index=0&id=9b7ca2b4&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b7ca2b4"]])

export default __exports__